__turbopack_context__.v({
  "fourthScreenContainer": "FourthScreenInfra-module-scss-module__T_mOBa__fourthScreenContainer",
  "fourthScreenDescription": "FourthScreenInfra-module-scss-module__T_mOBa__fourthScreenDescription",
  "fourthScreenImgBig": "FourthScreenInfra-module-scss-module__T_mOBa__fourthScreenImgBig",
  "fourthScreenImgBigMob": "FourthScreenInfra-module-scss-module__T_mOBa__fourthScreenImgBigMob",
  "fourthScreenImgBox": "FourthScreenInfra-module-scss-module__T_mOBa__fourthScreenImgBox",
  "fourthScreenImgSmall": "FourthScreenInfra-module-scss-module__T_mOBa__fourthScreenImgSmall",
  "fourthScreenImgSmallMob": "FourthScreenInfra-module-scss-module__T_mOBa__fourthScreenImgSmallMob",
  "fourthScreenImgWrapper": "FourthScreenInfra-module-scss-module__T_mOBa__fourthScreenImgWrapper",
  "fourthScreenSmallImg": "FourthScreenInfra-module-scss-module__T_mOBa__fourthScreenSmallImg",
  "fourthScreenSvg_one": "FourthScreenInfra-module-scss-module__T_mOBa__fourthScreenSvg_one",
  "fourthScreenSvg_two": "FourthScreenInfra-module-scss-module__T_mOBa__fourthScreenSvg_two",
  "fourthScreenTextBox": "FourthScreenInfra-module-scss-module__T_mOBa__fourthScreenTextBox",
  "fourthScreenTitle": "FourthScreenInfra-module-scss-module__T_mOBa__fourthScreenTitle",
  "fourthScreenWrapper": "FourthScreenInfra-module-scss-module__T_mOBa__fourthScreenWrapper",
  "imagesContainerMob": "FourthScreenInfra-module-scss-module__T_mOBa__imagesContainerMob",
  "svgClass": "FourthScreenInfra-module-scss-module__T_mOBa__svgClass",
  "zIndexMinusOne": "FourthScreenInfra-module-scss-module__T_mOBa__zIndexMinusOne",
});
